// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import i18n from '@/translations'
import store from '@/store'
import App from './App'
import router from './router'
import { getDefaults } from '@/utils/importUtil'
import 'bootstrap'
import notificationPlugin from '@/plugin/notificationPlugin'
import '@/scss/app.scss'
import Datepicker from 'vuejs-datepicker'
import fontawesome from '@fortawesome/fontawesome'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import regular from '@fortawesome/fontawesome-free-regular'
import faSpinner from '@fortawesome/fontawesome-free-solid/faSpinner'
import faChevronLeft from '@fortawesome/fontawesome-free-solid/faChevronLeft'
import faChevronRight from '@fortawesome/fontawesome-free-solid/faChevronRight'
import faChevronUp from '@fortawesome/fontawesome-free-solid/faChevronUp'
import faChevronDown from '@fortawesome/fontawesome-free-solid/faChevronDown'
import faList from '@fortawesome/fontawesome-free-solid/faList'
import faListAlt from '@fortawesome/fontawesome-free-solid/faListAlt'
import faMusic from '@fortawesome/fontawesome-free-solid/faMusic'
import faClock from '@fortawesome/fontawesome-free-solid/faClock'
import faBullhorn from '@fortawesome/fontawesome-free-solid/faBullhorn'
import faCalendarAlt from '@fortawesome/fontawesome-free-solid/faCalendarAlt'
import faBullseye from '@fortawesome/fontawesome-free-solid/faBullseye'
import faQuestionCircle from '@fortawesome/fontawesome-free-solid/faQuestionCircle'
import faSearch from '@fortawesome/fontawesome-free-solid/faSearch'
import faPlus from '@fortawesome/fontawesome-free-solid/faPlus'
import faPlay from '@fortawesome/fontawesome-free-solid/faPlay'
import faPause from '@fortawesome/fontawesome-free-solid/faPause'
import faSignOutAlt from '@fortawesome/fontawesome-free-solid/faSignOutAlt'
import faCheckCircle from '@fortawesome/fontawesome-free-solid/faCheckCircle'
import faExclamationCircle from '@fortawesome/fontawesome-free-solid/faExclamationCircle'
import faInfoCircle from '@fortawesome/fontawesome-free-solid/faInfoCircle'
import faEllipsisV from '@fortawesome/fontawesome-free-solid/faEllipsisV'
import faCube from '@fortawesome/fontawesome-free-solid/faCube'
import faBars from '@fortawesome/fontawesome-free-solid/faBars'
import faTimes from '@fortawesome/fontawesome-free-solid/faTimes'
import faEject from '@fortawesome/fontawesome-free-solid/faEject'
import faStepForward from '@fortawesome/fontawesome-free-solid/faStepForward'
import faArrowAltCircleDown from '@fortawesome/fontawesome-free-solid/faArrowAltCircleDown'
import faRandom from '@fortawesome/fontawesome-free-solid/faRandom'
import faUsers from '@fortawesome/fontawesome-free-solid/faUsers'
import faCog from '@fortawesome/fontawesome-free-solid/faCog'
import faEdit from '@fortawesome/fontawesome-free-solid/faEdit'
import faTrashAlt from '@fortawesome/fontawesome-free-solid/faTrashAlt'
import faCopy from '@fortawesome/fontawesome-free-solid/faCopy'
import faCheck from '@fortawesome/fontawesome-free-solid/faCheck'
import faChartBar from '@fortawesome/fontawesome-free-solid/faChartBar'

fontawesome.library.add(
  regular, faSpinner, faChevronLeft, faChevronRight, faChevronUp, faChevronDown, faList, faMusic, faListAlt, faClock, faBullhorn, faCalendarAlt,
  faBullseye, faQuestionCircle, faSignOutAlt, faSearch, faPlus, faPlay, faPause, faInfoCircle, faExclamationCircle,
  faCheckCircle, faEllipsisV, faCube, faBars, faTimes, faEject, faStepForward, faArrowAltCircleDown, faUsers, faRandom,
  faCog, faEdit, faCopy, faTrashAlt, faCheck, faChartBar
)

Vue.use(notificationPlugin)
Vue.config.productionTip = false

// import all shared components and make them global
const components = getDefaults(require.context('@/components/shared/', false, /\.vue$/))
Object.keys(components).forEach(key => Vue.component(key, components[key]))

Vue.component('Datepicker', Datepicker)
Vue.component('FontAwesomeIcon', FontAwesomeIcon)

/* eslint-disable no-new */
new Vue({
  el: '#root',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/m2/service-worker.js')
  })
}



// WEBPACK FOOTER //
// ./src/main.js